import * as L from 'leaflet';
import { ControlOptions } from 'leaflet';
import { faLayerGroup } from '@fortawesome/pro-regular-svg-icons';
import { createBasicLeafletIconButton, toggleActiveClass } from './helpers';

export class ControlPdfLayer extends L.Control {
  private panel: HTMLElement;
  private isOpen = false;
  private map: L.Map;


  constructor(options: Partial<ControlOptions> & {elementId: string}) {
    super(options);
  }

  initialize(options: Partial<ControlOptions> & {elementId: string}) {
    this.panel = L.DomUtil.get(options.elementId);
  }

  onAdd(map: L.Map) {
    if(!this.panel) {
      console.error("[ControlPdfLayer]: Panel not found")
      return;
    }

    this.map = map;
    const anchorElement = createBasicLeafletIconButton(faLayerGroup);

    L.DomEvent.disableClickPropagation(this.panel);
    L.DomEvent.disableScrollPropagation(this.panel);

    const controlsContainer: HTMLElement = map.getContainer().querySelector('.leaflet-control-container');
    controlsContainer.classList.add('leaflet-anim-control-container', 'closed');

    L.DomEvent.on(anchorElement, 'click', () => {
      this.togglePanel();
      toggleActiveClass(anchorElement);
    });

    const closeButton: HTMLElement = this.panel.querySelector('qpoint-icon');
    L.DomEvent.on(closeButton, 'click', () => {
      this.togglePanel();
      toggleActiveClass(anchorElement);
    });

    return anchorElement;
  }

  togglePanel() {
    const controlsContainer: HTMLElement = this.map.getContainer().querySelector('.leaflet-control-container');
    if (this.isOpen) {
      this.panel.classList.add('closed');
      this.panel.classList.remove('opened');
      controlsContainer.classList.remove('opened');
      controlsContainer.classList.add('closed');
    } else {
      this.panel.classList.add('opened');
      this.panel.classList.remove('closed');
      controlsContainer.classList.remove('closed');
      controlsContainer.classList.add('opened');
    }
    this.isOpen = !this.isOpen;
  }
}
